(() => {
  const closeMenus = (except) => document.querySelectorAll('.lb-nav-details[open]').forEach(menu => { if (menu !== except) menu.open = false; });
  document.addEventListener('toggle', event => { if (event.target.matches?.('.lb-nav-details') && event.target.open) closeMenus(event.target); }, true);
  document.addEventListener('click', event => { if (!event.target.closest('.lb-nav-details')) closeMenus(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const menu = document.querySelector('.lb-nav-details[open]'); closeMenus(); menu?.querySelector('summary')?.focus(); } });
  const syncReviews = () => {
    const target = document.querySelector('[data-lb-review-summary]');
    const section = document.querySelector('[id$="__1728152082f75d55dc"]');
    if (!target || !section) return;
    const text = section.innerText;
    const match = text.match(/(\d(?:\.\d+)?)\s*average\s*(\d[\d,]*)\s*reviews/i);
    if (match) target.textContent = `${match[1]} / 5 · ${match[2]} reviews`;
  };
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[id$="__1728152082f75d55dc"]');
    if (section) { new MutationObserver(syncReviews).observe(section, {childList:true,subtree:true}); syncReviews(); }
  });
})();
